import { onDeviceResize, pageTransitionAction } from './common/actions';
import { sessionValidateAction } from './userAuth/actions';

/* istanbul ignore next */
const sessionValidate = sessionValidateAction.request;

export const globalActions = [onDeviceResize, sessionValidate];

export const globalPageTransitionActions = [pageTransitionAction];
